/**
 * Entry point of the Schadenmanager add-in. Telemetry is not started here: the
 * portal's consent decision arrives over the handshake and decides it.
 */
import { InsightsBoundary } from '@this/app-shared/dist/tools/insights/Boundary.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/index.js';
import './index.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <InsightsBoundary>
            <App />
        </InsightsBoundary>
    </StrictMode>
);
